import { GlobalStatus } from "@gtpl/shared-models/common-models";

export class PurchaseProductDetailedReqDto {
    purchaseId?: number;

    constructor(
        purchaseId?: number,
     
    ) {
        this.purchaseId = purchaseId;
    
    }
}